<template>
  <transition name="modal">
    <div class="modal-mask h-100 d-table">
      <div class="modal-wrapper d-table-cell v-middle">
        <div class="modal-container p-0 col-md-4 m-auto">
          <div class="modal-body p-0 mb-0 border-top border-primary border-3x">
           <div class="card bg-white rounded">
             <div class="card-body pr-3 pb-3 pt-5 pl-5">
               <h3 class="font-weight-bold">Welches Datum soll für dieses Foto verwendet werden?</h3>
               <form>
                 <div class="form-group mt-3">
                   <label class="radio-inline font-16">
                     <input type="radio" v-model="date_type" value="original_date" name="optradio" class="w-auto date-radio-input"> Originaldatum
                   </label>
                 </div>
                 <div class="form-group ">
                   <label class="radio-inline font-16">
                     <input type="radio" v-model="date_type" value="other_date" name="optradio" class="w-auto date-radio-input"> anderes Datum
                   </label>
                   <input class="input--style-2 form-control w-auto input-style d-inline-block ml-2" id="datepicker-date" :value="setDate(photo_date)" data-date-format="dd.mm.yyyy" readonly>
                 </div>

                 <div class="form-group ">
                   <label class="radio-inline font-16">
                     <input type="checkbox" v-model="copy_flag" value="true" name="copy_flag" class="w-auto date-radio-input"> Planposition übernehmen (wenn vorhanden)
                   </label>
                 </div>
                 <div class="form-group">
                   <label class="radio-inline font-16">
                     <input type="checkbox" v-model="copy_tags" value="true" name="copy_tags" class="w-auto date-radio-input"> Schlagworte übernehmen
                   </label>
                 </div>
                 <div class="form-group pb-4">
                   <label class="radio-inline font-16">
                     <input type="checkbox" v-model="copy_desc" value="true" name="copy_desc" class="w-auto date-radio-input"> Beschreibung übernehmen
                   </label>
                 </div>


               </form>
               <div class="modal-content-test text-right">
                 <div class="save-image-btns">
                   <button class="btn btn-danger btn-sm btn-save-image" type="button" @click="$emit('close')">
                     Abbrechen
                   </button>
                   <button class="btn btn-primary btn-sm btn-save-image" :disabled="loading" @click="save">
                     <span v-if="loading" class="spinner-border  pr-1 spinner-border-sm" role="status">
                       <span class="sr-only">Loading...</span>
                     </span>  Speichern
                   </button>
                 </div>
               </div>
             </div>
           </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import {formatAsInputDate} from "../common";
export default {
  props: ['loading'],
  data(){
    return {
      date_type: 'original_date',
      photo_date: new Date(),
      copy_flag: true,
      copy_tags: true,
      copy_desc: true
    }
  },
  mounted() {
    let _this = this
    $('#datepicker-date').datepicker({
      autoclose: true,
      todayHighlight: true,
    }).on('changeDate', function(ev){
      if(ev.date !== undefined) {
        _this.photo_date = new Date(formatAsInputDate(ev.target.value));
        console.log('Selected Date: UNDEFINED', ev.target.value, _this.photo_date)
      } else {
        _this.photo_date = new Date(formatAsInputDate(_this.photo_date));
        console.log('Selected Date: DEFINED', _this.photo_date)
      }
    });
  },
  methods: {

    setDate(d){
      let day = d.getDate()
      let month = d.getMonth() + 1
      day = day < 10 ? `0${day}` : day
      month = month < 10  ? `0${month}`: month
      return `${day}.${month}.${d.getFullYear()}`;
    },
    save(){
      console.log('__SAVE__', this)
      this.$emit('save',{
        type: this.date_type,
        date: this.photo_date,
        copy_tags: this.copy_tags,
        copy_flag: this.copy_flag,
        copy_desc: this.copy_desc
      });
    }
  }
}
</script>
<style scoped>
.v-middle{
  vertical-align: middle;
}
.font-16{
  font-size: 18px;
  font-weight: bold;
}
.date-radio-input{
  min-width: 19px;
  min-height: 19px;
  vertical-align: middle;
  margin-top: -3px;
  margin-right: 3px;
}
</style>



// WEBPACK FOOTER //
// src/components/photo/ConfirmDateModal.vue